import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';
import '../../cssfiles/homepage.css';

var barchartoptions = {
    chart: {
        type: 'bar',
        height: '300px',
        borderRadius:8,
        //stacked: props.widgetprop.props.extended.stacked,
        toolbar:{
            show:true,
            tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: true,
                zoomout: true,
                pan: false,
                reset: false
            },
            dropShadow: {
            enabled: false
            }
        },
        offsetX:-9,
    },
    grid: {
        show: false,      // you can either change hear to disable all grids
        xaxis: {
            lines: {
                show: false  //or just here to disable only x axis grids
            }
        },  
        yaxis: {
            lines: { 
                show: false  //or just here to disable only y axis
            }
        },   
    },
    stroke: {
    show: false,
    //curve: 'straight',
    //colors: [],
    width: 1.75,
    dashArray: 0, 
    },
    plotOptions: {
        /*bar: {
            columnWidth: props.widgetprop.props.extended.columnWidth,
            horizontal: props.widgetprop.props.extended.horizontal,
            borderRadius: props.widgetprop.props.extended.borderRadius,
            borderRadiusApplication: props.widgetprop.props.extended.borderRadiusApplication,
            borderRadiusWhenStacked: 'last',
        }*/
    }, 
    //colors: "#FFFFFF",
    //colors: [...color_properties],
    dataLabels: {
        enabled: false,
    },
    forecastDataPoints: {
        //count: props.widgetprop.props.extended.borderRadiusApplication,
        fillOpacity: 0.2,
        strokeWidth: undefined,
        dashArray: 1,
    },
    legend: {
        show: true,
        fontSize: '12px',
        fontWeight:400,
        fontFamily:'Roboto',
        labels: {
            colors:"#3A4452",//"var(--primary-text)",
        },
        position: 'bottom',
        //showForSingleSeries: true,
        //customLegendItems: ['Maximum Demand '],
        markers: {
            fillColors: [],
            radius: 12,
            height:"10px",width:"10px",
        }
    },
    xaxis: { 
        axisBorder: {
            show: false,
        },
        axisTicks:{
            show:false
        },
        labels: {
            rotate: -45,
            rotateAlways: false,
            hideOverlappingLabels: true,
            style: {                                
                fontSize: '12px',
                fontWeight: 400,
                colors: "#3A4452",//"var(--secondary-text-axis)"
                
            },
        },
    },
    responsive: [
        {
            breakpoint: 1000,
            options: {
                xaxis: {
                    labels: {
                        rotate: -45,
                        rotateAlways: true,
                    }
                }
            }
        },
        {
            breakpoint: 600,
            options: {
                xaxis: {
                    labels: {
                        rotate: -60,
                        rotateAlways: true,
                    }
                }
            }
        }
    ],
    yaxis: {
        labels: {
            style: {                                
                fontSize: '12px',
                fontWeight: 400,
                colors:"#3A4452", //"var(--secondary-text-axis)"
                
            },
        },
    },
};



export default function Barchartcard (props) {
    
    const [tagporpslist, setTagpropslist] = useState([])
    const [editorseries, setEditorseries] = useState([])
    const [chartoptions, setChartoption] = useState(barchartoptions)

    var series = 
        {
          name: '',
          color: '',
          data: [
            {
              x: 'Jan',
              y: 1292,
            },
            {
              x: 'Feb',
              y: 4432,
            },
            {
              x: 'Mar',
              y: 5423,
            },
            {
              x: 'Apr',
              y: 6653,
            },
            {
              x: 'May',
              y: 8133,
            },
            {
              x: 'Jun',
              y: 7132,
            },
            {
              x: 'Jul',
              y: 7332,
            },
            {
              x: 'Aug',
              y: 6553,
            },
            {
              x: 'Sep',
              y: 6553,
            },
            {
              x: 'Oct',
              y: 6553,
            },
            {
              x: 'Nov',
              y: 6553,
            },
            {
              x: 'Dec',
              y: 6553,
            }
          ],
          type:"column"
        }

    useEffect(() => {
        if(props.extendedprops !== undefined) {
            if(props.extendedprops.hasOwnProperty("tagpropslist")) {
                setTagpropslist(props.extendedprops.tagpropslist)
                var seriesdata = []
                for(let i=0; i<props.extendedprops.tagpropslist.length; i++) {
                    var newdata = {...series}
                    newdata.name = props.extendedprops.tagpropslist[i].discription
                    newdata.color = props.extendedprops.tagpropslist[i].textcolor

                    seriesdata.push(newdata)
                }
                /*var chartpro = {...chartoptions}
                //var chartpro = Object.assign({}, chartoptions)
                chartpro.xaxis.labels.style.fontSize = props.extendedprops.font.fontsize
                chartpro.xaxis.labels.style.fontFamily = props.extendedprops.font.fonttype
                chartpro.xaxis.labels.style.colors = props.extendedprops.font.color
                console.log("chartpro ", chartpro)
                
                setChartoption(chartoptions => ({
                    ...chartoptions,
                    ...chartpro
                }))*/
                console.log("chartoptions ",chartoptions)
                setEditorseries(seriesdata)
            }
        }
        //console.log("tagporpslist ",props.extendedprops.tagpropslist)
    },[props.extendedprops])


    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto'}}>
            <Chart options={chartoptions} series={editorseries} type='bar' height="85%" width="100%" />
        </div>
        
    )
}